import React, { useState } from "react";
import "../assets/Contact.css";

const faqs = [
  {
    question: "How can I reach customer support?",
    answer: "You can reach us via phone, email, or by filling out the contact form. Our team is available Mon-Fri 9AM - 6PM."
  },
  {
    question: "Do you offer 24/7 support?",
    answer: "Currently, our support team is available during business hours only. For urgent issues, please email us directly."
  },
  {
    question: "Where is your office located?",
    answer: "Our headquarters is in Muzaffarpur,Bihar (India) but we provide services across the India."
  }
];


export default function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!form.name.trim()) newErrors.name = "Name is required";
    if (!form.email.includes("@")) newErrors.email = "Valid email is required";
    if (!form.message.trim()) newErrors.message = "Message cannot be empty";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    // WhatsApp integration
    const phoneNumber = "919876543210"; // replace with your WhatsApp number
    const text = `Hello! I am *${form.name}*.
Email: ${form.email}
Phone: ${form.phone || "N/A"}
Message: ${form.message}`;
    
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank"); // Open WhatsApp

    setSuccess(true);
    setForm({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="contact-hero">
        <h1>Contact Us</h1>
        <p>We’d love to hear from you! Reach out anytime and our team will get back quickly.</p>
      </section>

      {/* Contact Info */}
      <section className="contact-info">
        <div className="info-card">
          <h3>📍 Office</h3>
          <p>Muzaffarpur, India</p>
        </div>
        <div className="info-card">
          <h3>📞 Phone</h3>
          <p>+91 1234567890</p>
        </div>
        <div className="info-card">
          <h3>✉️ Email</h3>
          <p>support@yourcompany.com</p>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-form">
        <h2>Get in Touch</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={form.name}
              onChange={handleChange}
            />
            {errors.name && <span className="error">{errors.name}</span>}
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={form.email}
              onChange={handleChange}
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>

          <div className="form-group">
            <input
              type="text"
              name="phone"
              placeholder="Your Phone"
              value={form.phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <textarea
              name="message"
              placeholder="Your Message"
              value={form.message}
              onChange={handleChange}
            />
            {errors.message && <span className="error">{errors.message}</span>}
          </div>

          <button type="submit">Send via WhatsApp</button>
        </form>
      </section>

      {/* FAQ Accordion */}
      <section className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                className="faq-question"
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
              >
                {item.question}
              </button>
              {openFaq === index && <p className="faq-answer">{item.answer}</p>}
            </div>
          ))}
        </div>
      </section>

      {/* Success Modal */}
      {success && (
        <div className="modal-overlay" onClick={() => setSuccess(false)}>
          <div className="modal">
            <h3>✅ Redirecting to WhatsApp!</h3>
            <p>Click close if WhatsApp did not open automatically.</p>
            <button onClick={() => setSuccess(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
